import React from "react";
import { node, string } from "prop-types";

import * as S from "./styled";

const ErrorMessage = ({ children, className }) => (
  <S.ErrorContent className={className}>
    <S.ErrorIcon />
    <S.ErrorText>{children}</S.ErrorText>
  </S.ErrorContent>
);

ErrorMessage.propTypes = {
  children: node,
  className: string
};

ErrorMessage.defaultProps = {
  children: "Sorry, something went wrong",
  className: ""
};

export default ErrorMessage;
